import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
  DataSourceRequestState
} from '@progress/kendo-data-query';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LibraryConfigService } from '@logicaghl/util-library';

@Injectable({
  providedIn: 'root'
})
export class ContractService {

  private BASE_URL =
    // tslint:disable-next-line: max-line-length
    `${this.CONFIGURATION.baseUrls.tcServer}/${this.CONFIGURATION.baseUrls.tcApiUrl}/${this.CONFIGURATION.baseUrls.tcContractUrl}/${this.CONFIGURATION.baseUrls.tcContractFindService}`;

  constructor(
    private http: HttpClient,
    @Inject(LibraryConfigService) private CONFIGURATION
    ) { }

  public findContract(state: DataSourceRequestState, contractValue: string, documentValue: string): Observable<any> {
      // tslint:disable-next-line: max-line-length
      const queryStr = `${toDataSourceRequestString(state)}&ContractNumber=${contractValue.toUpperCase()}&Document=${documentValue.toUpperCase()}&OnlyLatin=true`;
      // + contractValue ? '&ContractNumber=' + contractValue : '&Document=' + documentValue;
      // queryStr +=  '&ContractNumber=' + contractValue + '&Document=' + documentValue;
      const hasGroups = state.group && state.group.length;
      return this.http
      .get(`${this.BASE_URL}?${queryStr}`)
      .pipe(
          map(({Data, Total}: any) => // Process the response
              (<any>{
                  // If there are groups, convert them to a compatible format
                  Data: hasGroups ? translateDataSourceResultGroups(Data) : Data,
                  Total: Total
              })
          )
      );
  }
  private serializeModels(data?: any): string {
      return data ? `&models=${JSON.stringify([data])}` : '';
  }
}
